export default __webpack_public_path__ + "static/linkBg7-4720e2841d42ae7468395b7930324da5.png";